import { useMutation, type UseMutationOptions } from 'react-query';
import { updateSubscriptionStatus, updateBusinessPlan } from '../api';
import type { UpdateSubscriptionRequest, UpdateBusinessPlanRequest } from '../types';

export const useUpdateSubscriptionStatus = (
  locationId: string,
  options: UseMutationOptions<void, unknown, UpdateSubscriptionRequest> = {}
) =>
  useMutation({
    mutationFn: (body: UpdateSubscriptionRequest) => updateSubscriptionStatus(locationId, body),
    ...options,
  });

export const useUpdateBusinessPlan = (options: UseMutationOptions<void, unknown, UpdateBusinessPlanRequest> = {}) =>
  useMutation({
    mutationFn: (body: UpdateBusinessPlanRequest) => updateBusinessPlan(body),
    ...options,
  });
